import { render, staticRenderFns } from "./paymentParameterSwitching.vue?vue&type=template&id=5a772690&scoped=true&"
import script from "./paymentParameterSwitching.vue?vue&type=script&lang=js&"
export * from "./paymentParameterSwitching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a772690",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a772690')) {
      api.createRecord('5a772690', component.options)
    } else {
      api.reload('5a772690', component.options)
    }
    module.hot.accept("./paymentParameterSwitching.vue?vue&type=template&id=5a772690&scoped=true&", function () {
      api.rerender('5a772690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/paymentParameterSwitching.vue"
export default component.exports